

require('xo-ui-components/src/directionality/directive');

define(['jquery', 'angular', 'text!./template.html', 'components/xo-ui-components/src/error-tooltip/directive'], function ($, angular, template) {

    return angular.module('xo-guest.passwordInput', ['squid', 'xo-error-tooltip.directive']).directive('xoPasswordInput', function ($timeout, $locale) {
        return {
            template: template,

            scope: {
                user: '=',
                singlePassword: '=?', // enable single password - optional attribute
                isDisabled: '=?' // disable password field - optional attribute
            },

            controller: function controller($scope) {
                $scope.locale = $locale;

                $scope.passwordToolTip = 'show';
                $scope.passwordMismatch = 'hide';

                $scope.requirementLength = 'active';
                $scope.requirementNumberSymbol = 'active';

                /*
                 * single password case
                 * flags and functions to enable single password hide and
                 * show password feature
                 */
                function enableSinglePassword() {
                    $scope.showRawPassword = false;
                    $scope.showPasswordTextToggleLink = false;

                    $scope.toggleShowRawPassword = function ($event) {
                        var $passwordEl = $('#password');
                        var valLength = $passwordEl.val().length;

                        $event.preventDefault();
                        $scope.showRawPassword = !$scope.showRawPassword;

                        if ($scope.showRawPassword) {
                            $passwordEl.prop('type', 'text');
                        } else {
                            $passwordEl.prop('type', 'password');
                        }

                        // timeout is need to get this function running after
                        // the onPasswordBlur function
                        $timeout(function () {
                            $passwordEl.focus();
                            // firefox set the cursor to the end of the value text
                            $passwordEl.get(0).setSelectionRange(valLength, valLength);
                        });
                    };
                }

                /*
                    The next 2 methods serve to allow passwordValidate & confirmPasswordValidate directives
                    to access + change the scope variables inside here as the scopes
                    in these directives are different and do not inherit from here.
                */
                this.setScopeProp = function (prop, newVal) {
                    $scope[prop] = newVal;
                };

                this.getScopeProp = function (prop) {
                    return $scope[prop];
                };

                // 'singlePassword' case - show the 'hide/show' password link
                $scope.onPasswordFocusBlur = function ($event, focused) {
                    var passwordValLength = $scope.user.password && $scope.user.password.length;
                    if ($scope.singlePassword) {
                        if (focused) {
                            $scope.showPasswordTextToggleLink = true;
                        } else {
                            // if length is zero then it is false
                            $scope.showPasswordTextToggleLink = passwordValLength ? true : false;
                        }
                    }
                };

                // enable singlepassword if $scope.singlePassword is set to true
                $scope.$watch('singlePassword', function (newVal, oldVal) {
                    if (newVal) {
                        enableSinglePassword();
                    }
                });
            }
        };
    }).directive('passwordValidate', function () {
        return {
            require: ['^ngModel', '^xoPasswordInput'],
            link: function link(scope, elem, attrls, controllers) {
                var ngModelC = controllers[0];
                var passwordInputC = controllers[1];

                ngModelC.$setValidity('password', false);

                var fourSequence = function fourSequence(value) {
                    value += ' ' + value.split('').reverse().join('');
                    var sequences = '`1231234234534564567567867897890890-90-= ' + // row 1
                    'qwerwertertyrtyutyuiyuiouiopiop[op[]p[]\\ ' + // row 2
                    'asdfsdfgdfghfghjghjkhjkljkl;kl;\' ' + // row 3
                    'zxcvxcvbcvbnvbnmbnm,nm,.m,./ ' + // row 4
                    '~!@#!@#$@#$%#$%^$%^&%^&*^&*(&*()*()_()_+ ' + // shift + row 1
                    'QWERWERTERTYRTYUTYUIYUIOUIOPIOP{OP{}P{}| ' + // shift + row 2
                    'ASDFSDFGDFGHFGHJGHJKHJKLJKL:KL:\' ' + // shift + row 3
                    'ZXCVXCVBCVBNVBNMBNM<NM<>M<>?'; // shift + row 4

                    var len = value.length;
                    for (var i = 0; i < len - 3; i++) {
                        if (sequences.indexOf(value.substr(i, 4)) > -1) {
                            return false;
                        }
                    }
                    return true;
                };

                ngModelC.$parsers.unshift(function (viewValue) {
                    passwordInputC.setScopeProp('requirementLength', viewValue.length >= 8 && viewValue.length <= 20 ? false : 'active');
                    passwordInputC.setScopeProp('requirementNumberSymbol', /\d/.test(viewValue) || /[\-!@#$%\^&*()_+|~=`{}\[\]:';'<>?,.\/\\]/.test(viewValue) ? false : 'active');

                    passwordInputC.setScopeProp('requirementInfoSec', false);
                    if (scope.user.country === 'AU') {
                        var lcViewVal = viewValue.toLowerCase();
                        var firstName = scope.user && scope.user.first_name && scope.user.first_name.toLowerCase();
                        var lastName = scope.user && scope.user.last_name && scope.user.last_name.toLowerCase();
                        var dob = scope.user && scope.user.dob_day + '/' + scope.user.dob_month + '/' + scope.user.dob_year;
                        if (lcViewVal.indexOf(firstName) !== -1 || lcViewVal.indexOf(lastName) !== -1 || lcViewVal.indexOf(dob) !== -1) {
                            passwordInputC.setScopeProp('requirementInfoSec', 'active');
                        }
                    }

                    passwordInputC.setScopeProp('restrictionEmail', false);
                    passwordInputC.setScopeProp('restrictionFourRepeated', viewValue.length > 3 && /(.)\1{3}/.test(viewValue) ? 'active' : false);
                    passwordInputC.setScopeProp('restrictionNonValidCharacters', /[\x00-\x08\x0E-\x1F\x80-\xFF ]/.test(viewValue) ? 'active' : false);
                    passwordInputC.setScopeProp('restrictionFourSequence', viewValue.length > 3 && !fourSequence(viewValue) ? 'active' : false);

                    var requirements = !(passwordInputC.getScopeProp('requirementLength') || passwordInputC.getScopeProp('requirementNumberSymbol') || passwordInputC.getScopeProp('requirementInfoSec'));
                    var restrictions = !(passwordInputC.getScopeProp('restrictionEmail') || passwordInputC.getScopeProp('restrictionFourRepeated') || passwordInputC.getScopeProp('restrictionNonValidCharacters') || passwordInputC.getScopeProp('restrictionFourSequence'));

                    ngModelC.$setValidity('password', requirements && restrictions);
                    passwordInputC.setScopeProp('passwordToolTip', requirements && restrictions ? 'hide' : 'show');
                    return viewValue;
                });
            }
        };
    }).directive('confirmPasswordValidate', function () {
        return {
            require: ['^ngModel', '^xoPasswordInput'],
            link: function link(scope, elem, attrls, controllers) {
                var ngModelC = controllers[0];
                var passwordInputC = controllers[1];

                ngModelC.$setValidity('confirmPassword', false);

                scope.$watch('user.password', function (newValue) {
                    var cPass = scope.user.confirmPassword;
                    if (cPass && cPass.length && cPass !== newValue) {
                        ngModelC.$setValidity('confirmPassword', false);
                        passwordInputC.setScopeProp('passwordMismatch', 'show');
                    }
                });

                ngModelC.$parsers.unshift(function (viewValue) {
                    var passwordVal = scope.user.password;

                    passwordInputC.setScopeProp('restrictionMatch', passwordVal && viewValue.length > 0 && passwordVal.indexOf(viewValue) === 0 && passwordVal === viewValue);

                    ngModelC.$setValidity('confirmPassword', passwordVal === viewValue);

                    passwordInputC.setScopeProp('passwordMismatch', passwordInputC.getScopeProp('restrictionMatch') ? 'hide' : 'show');
                    return viewValue;
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/passwordInput/directive.js
// module id = ./components/xo-guest-components/src/guest/passwordInput/directive.js
// module chunks = 1